import { Box, Card, Divider, Grid, IconButton, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Skeleton from '@mui/material/Skeleton';
// import SaveAsIcon from '@mui/icons-material/SaveAs';
import { NoData } from "../../../Base/views/NotAuthorized";
import { getUserData } from "../../../Base/helper/baseFunctions";

const Dashboard = ({ setValue, setAccordian }) => {
    const userData = getUserData();
    
    const { designation_options } = useSelector(state => state?.AncillaryReducer?.DesignationReducer);
    const { leavingreasonData } = useSelector(state => state?.AncillaryReducer?.LeavingReasonReducer);
    const { businessunitData } = useSelector(state => state.AncillaryReducer?.BusinessUnitReducer);
    const { subBusinessunitData } = useSelector(state => state.AncillaryReducer?.SubBusinessUnitReducer);
    const { leavetypes_options } = useSelector(state => state.LeaveReducer?.LeaveTypeReducer);
    const { employment_type_options } = useSelector(state => state?.AncillaryReducer?.EmploymentTypeReducer);
    const { cost_center_options } = useSelector(state => state?.AncillaryReducer?.CostCenterReducer);
    const { workLocation_options, isLoading } = useSelector(state => state?.AncillaryReducer?.WorkLocationReducer);
    const { holidayData } = useSelector(state => state?.LeaveReducer?.YearlyHolidayCalendarReducer)
    const { optionalHolidayData } = useSelector(state => state?.LeaveReducer?.OptionalHolidayCalendarReducer)
    const { proof_type_data } = useSelector(state => state?.AncillaryReducer?.ProofTypeReducer)
    const { leavereasonData } = useSelector(state => state?.LeaveReducer?.LeaveReasonReducer);
    // const { mytime_options } = useSelector(state => state.LeaveReducer?.MyTimeConfigureReducer);
    const { week_off_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
    const { work_hours_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
    const { studylevel_options } = useSelector(state => state?.AncillaryReducer?.StudyLevelReducer);
    const { studyprogram_options } = useSelector(state => state?.AncillaryReducer?.StudyProgramReducer);
    const { shift_time_options } = useSelector(state => state?.LeaveReducer?.ShiftTimeConfigureReducer);
    const { aiConfigData, AiConfigLoading } = useSelector((state) => state.AncillaryReducer?.AIConfigReducer);
    const { clearanceTypeLoading, clearanceTypeData, exitReasonsData } = useSelector((state) => state?.EmployeeReducer?.ECMSReducer);
    const { report_schedule_data } = useSelector(state => state?.AncillaryReducer?.ReportSchedulerReducer);

    const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
    const FNFAccess = atsModuleData?.some((item) => item.module_name === "FNF");
    const leaveAccess = atsModuleData?.find((item) => item.module_name === "Leave");
    const leaveUserAccess = atsModuleData?.find((item) => item.module_name === "LMS User");

    const handleClick = (value, accordian) => {
        setValue(value);
        setAccordian(accordian)
    }

    const data = [
        { title: "Cost Center", data: cost_center_options || [], field_name: "name" },
        { title: "Designation", data: designation_options || [], field_name: "name" },
        { title: "Leaving Reason", data: leavingreasonData || [], field_name: "lreason_name" },
        { title: "Business Unit", data: businessunitData || [], field_name: "name" },
        { title: "Sub Business Unit", data: subBusinessunitData || [], field_name: "name" },
        { title: "Employment Type", data: employment_type_options || [], field_name: "etype_name" },
        { title: "Proof Type", data: proof_type_data || [], field_name: "name" },
        { title: "Study Level", data: studylevel_options || [], field_name: "name" },
        { title: "Study Program", data: studyprogram_options || [], field_name: "name" },
    ]

    const leaveData = [
        { title: "Leave Types", data: leavetypes_options || [], field_name: "name" },
        { title: "Public Holidays", data: holidayData || [], field_name: "name" },
        { title: "Optional Holidays", data: optionalHolidayData || [], field_name: "name" },
        { title: "Leave Reason", data: leavereasonData || [], field_name: "reason_name" },
        { title: "Shift Time", data: shift_time_options || [], field_name: "shift_name" },
    ]
    const myTimeData = [
        // { title: "Projects", data: mytime_options || [], field_name: "project_code" },
        { title: "Work Location", data: workLocation_options || [], field_name: "work_location_name" },
        { title: "Week Off Configuration", data: week_off_data || [], field_name: "day_name" },
        { title: "Work Hours", data: work_hours_data || [], field_name: "working_hours" },
    ]
    const ecmsConfig = [
        { title: "Asset Configuration", data: clearanceTypeData || [], field_name: "clearance_type" },
        { title: "Exit Reason Config", data: exitReasonsData || [], field_name: "exit_reason" },
    ]
    const reportSchedule = [
        { title: "Report Scheduler", data: report_schedule_data || [], field_name: "reports_list_name" },
    ]
    const aiData = [
        { title: "AI Configuration", data: aiConfigData || [], field_name: "ai_type" },
    ]
    const filteredValues = myTimeData?.filter((value) => {
        if (userData?.f_country_code !== "IND") {
            return value?.title !== "Week Off Configuration"
        }
        return true; // Show all items if the country code is "IND"
    });
    return (
        <>
            <Grid container sx={{ padding: "0px" }} className="hr-settings">
                {
                    data?.map((res, index) => {
                        return (
                            <Grid key={index} item xs={12} sm={6} md={3} lg={3} sx={{ padding: "10px" }}>
                                <Card className="shadow" sx={{ border: "1px solid #dbdada", borderRadius: "10px" }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "5px" }} className="card-title-dashboard">
                                        {
                                            isLoading ?
                                                <Skeleton width="85%">
                                                    <Typography>.</Typography>
                                                </Skeleton>
                                                : <Typography variant="h6" sx={{ marginLeft: "5px" }}>{res.title}</Typography>
                                        }
                                        <IconButton size="small" onClick={() => handleClick("2", res.title)} sx={{ color: "white" }}>
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Box>
                                    <Divider sx={{ backgroundColor: "#8534b9" }} />
                                    <Box sx={{ overflowY: "auto", maxHeight: "12rem", minHeight: "12rem", padding: "10px" }}>
                                        {
                                            isLoading ?
                                                <Skeleton variant="rectangular" width="90%" sx={{ margin: "10px" }}>
                                                    <div style={{ paddingTop: '60%' }} />
                                                </Skeleton>
                                                : res.data?.length > 0 ?
                                                    res.data?.map((item, id) => {
                                                        return (
                                                            <>
                                                                <Typography sx={{ padding: "2px" }} key={id} variant="body1">{item?.[res?.field_name]}</Typography>
                                                            </>
                                                        )
                                                    })
                                                    : <NoData title="No data found" />
                                        }
                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })
                }
                {userData?.f_country_code === "IND" && leaveAccess && leaveUserAccess && (
                    leaveData?.map((res, index) => {
                        return (
                            <Grid key={index} item xs={12} sm={6} md={3} lg={3} sx={{ padding: "10px" }}>
                                <Card className="shadow" sx={{ border: "1px solid #dbdada", borderRadius: "10px" }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "5px" }} className="card-title-dashboard">
                                        {
                                            isLoading ?
                                                <Skeleton width="85%">
                                                    <Typography>.</Typography>
                                                </Skeleton>
                                                : <Typography variant="h6" sx={{ marginLeft: "5px" }}>{res.title}</Typography>
                                        }
                                        <IconButton size="small" onClick={() => handleClick("3", res.title)} sx={{ color: "white" }}>
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Box>
                                    <Divider sx={{ backgroundColor: "#8534b9" }} />
                                    <Box sx={{ overflowY: "auto", maxHeight: "12rem", minHeight: "12rem", padding: "10px" }}>
                                        {
                                            isLoading ?
                                                <Skeleton variant="rectangular" width="90%" sx={{ margin: "10px" }}>
                                                    <div style={{ paddingTop: '60%' }} />
                                                </Skeleton>
                                                : res.data?.length > 0 ?
                                                    res.data?.map((item, id) => {
                                                        return (
                                                            <>
                                                                <Typography sx={{ padding: "2px" }} key={id} variant="body1">{item?.[res?.field_name]}</Typography>
                                                            </>
                                                        )
                                                    })
                                                    : <NoData title="No data found" />
                                        }
                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })
                )}

                {
                    filteredValues?.map((res, index) => {
                        return (
                            <Grid key={index} item xs={12} sm={6} md={3} lg={3} sx={{ padding: "10px" }}>
                                <Card className="shadow" sx={{ border: "1px solid #dbdada", borderRadius: "10px" }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "5px" }} className="card-title-dashboard">
                                        {
                                            isLoading ?
                                                <Skeleton width="85%">
                                                    <Typography>.</Typography>
                                                </Skeleton>
                                                : <Typography variant="h6" sx={{ marginLeft: "5px" }}>{res.title}</Typography>
                                        }
                                        <IconButton size="small" onClick={() => handleClick("4", res.title)} sx={{ color: "white" }}>
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Box>
                                    <Divider sx={{ backgroundColor: "#8534b9" }} />
                                    <Box sx={{ overflowY: "auto", maxHeight: "12rem", minHeight: "12rem", padding: "10px" }}>
                                        {
                                            isLoading ?
                                                <Skeleton variant="rectangular" width="90%" sx={{ margin: "10px" }}>
                                                    <div style={{ paddingTop: '60%' }} />
                                                </Skeleton>
                                                : res.data?.length > 0 ?
                                                    res.data?.map((item, id) => {
                                                        return (
                                                            <>
                                                                <Typography sx={{ padding: "2px" }} key={id} variant="body1">{item?.[res?.field_name]}</Typography>
                                                            </>
                                                        )
                                                    })
                                                    : <NoData title="No data found" />
                                        }
                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })

                }
                {
                    reportSchedule?.map((res, index) => {
                        return (
                            <Grid key={index} item xs={12} sm={6} md={3} lg={3} sx={{ padding: "10px" }}>
                                <Card className="shadow" sx={{ border: "1px solid #dbdada", borderRadius: "10px" }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "5px" }} className="card-title-dashboard">
                                        {
                                            isLoading ?
                                                <Skeleton width="85%">
                                                    <Typography>.</Typography>
                                                </Skeleton>
                                                : <Typography variant="h6" sx={{ marginLeft: "5px" }}>{res.title}</Typography>
                                        }
                                        <IconButton size="small" onClick={() => handleClick("5", res.title)} sx={{ color: "white" }}>
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Box>
                                    <Divider sx={{ backgroundColor: "#8534b9" }} />
                                    <Box sx={{ overflowY: "auto", maxHeight: "12rem", minHeight: "12rem", padding: "10px" }}>
                                        {
                                            isLoading ?
                                                <Skeleton variant="rectangular" width="90%" sx={{ margin: "10px" }}>
                                                    <div style={{ paddingTop: '60%' }} />
                                                </Skeleton>
                                                : res.data?.length > 0 ?
                                                    res.data?.map((item, id) => {
                                                        return (
                                                            <>
                                                                <Typography sx={{ padding: "2px" }} key={id} variant="body1">{item?.[res?.field_name]}</Typography>
                                                            </>
                                                        )
                                                    })
                                                    : <NoData title="No data found" />
                                        }
                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })
                }

                 { FNFAccess && (
                    ecmsConfig?.map((res, index) => {
                        return (
                            <Grid key={index} item xs={12} sm={6} md={3} lg={3} sx={{ padding: "10px" }}>
                                <Card className="shadow" sx={{ border: "1px solid #dbdada", borderRadius: "10px" }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "5px" }} className="card-title-dashboard">
                                        {
                                            clearanceTypeLoading ?
                                                <Skeleton width="85%">
                                                    <Typography>.</Typography>
                                                </Skeleton>
                                                : <Typography variant="h6" sx={{ marginLeft: "5px" }}>{res.title}</Typography>
                                        }
                                        <IconButton size="small" onClick={() => handleClick("6", res.title)} sx={{ color: "white" }}>
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Box>
                                    <Divider sx={{ backgroundColor: "#8534b9" }} />
                                    <Box sx={{ overflowY: "auto", maxHeight: "12rem", minHeight: "12rem", padding: "10px" }}>
                                        {
                                            clearanceTypeLoading ?
                                                <Skeleton variant="rectangular" width="90%" sx={{ margin: "10px" }}>
                                                    <div style={{ paddingTop: '60%' }} />
                                                </Skeleton>
                                                : res.data?.length > 0 ?
                                                    res.data?.map((item, id) => {
                                                        return (
                                                            <>
                                                                <Typography sx={{ padding: "2px" }} key={id} variant="body1">{item?.[res?.field_name]}</Typography>
                                                            </>
                                                        )
                                                    })
                                                    : <NoData title="No data found" />
                                        }
                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })
                )}

                {
                    aiData?.map((res, index) => {
                        return (
                            <Grid key={index} item xs={12} sm={6} md={3} lg={3} sx={{ padding: "10px" }}>
                                <Card className="shadow" sx={{ border: "1px solid #dbdada", borderRadius: "10px" }}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", padding: "5px" }} className="card-title-dashboard">
                                        {
                                            AiConfigLoading ?
                                                <Skeleton width="85%">
                                                    <Typography>.</Typography>
                                                </Skeleton>
                                                : <Typography variant="h6" sx={{ marginLeft: "5px" }}>{res.title}</Typography>
                                        }
                                        <IconButton size="small" onClick={() => handleClick("7", res.title)} sx={{ color: "white" }}>
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Box>
                                    <Divider sx={{ backgroundColor: "#8534b9" }} />
                                    <Box sx={{ overflowY: "auto", maxHeight: "12rem", minHeight: "12rem", padding: "10px" }}>
                                        {
                                            AiConfigLoading ?
                                                <Skeleton variant="rectangular" width="90%" sx={{ margin: "10px" }}>
                                                    <div style={{ paddingTop: '60%' }} />
                                                </Skeleton>
                                                : res.data?.length > 0 ?
                                                    res.data?.map((item, id) => {
                                                        if (res.field_name === "ai_type") {
                                                        const lines = [];

                                                        if (item?.resume_processor_selection)
                                                            lines.push(
                                                                <span key="resume">
                                                                <Box component="span" fontWeight="bold">Resume Processor:</Box> {item?.ai_token_json?.original_display_name || ""}
                                                                </span>
                                                        );

                                                        if (item?.profile_scoring_selection)
                                                            lines.push(
                                                                <span key="profile">
                                                                <Box component="span" fontWeight="bold">Profile Scoring:</Box> {item?.ai_token_json?.original_display_name || ""}
                                                                </span>
                                                        );

                                                        if (item?.jd_generation_selection)
                                                            lines.push(
                                                                <span key="ats_job">
                                                                <Box component="span" fontWeight="bold">ATS Job:</Box> {item?.ai_token_json?.original_display_name || ""}
                                                                </span>
                                                        );

                                                        return lines?.map((line, idx) => (
                                                        <Typography sx={{ padding: "2px" }} key={`${id}-${idx}`} variant="body1">
                                                            {line}
                                                        </Typography>
                                                        ));
                                                    } else {
                                                        return (
                                                        <Typography sx={{ padding: "2px" }} key={id} variant="body1">
                                                            {item?.[res.field_name]}
                                                        </Typography>
                                                        );
                                                    }
                                                    })
                                                    : <NoData title="No data found" />
                                        }
                                    </Box>
                                </Card>
                            </Grid>
                        )
                    })
                }

            </Grid>
        </>
    )
}

export default Dashboard;